<template>
  <div class="widget-button" @click.stop.prevent="shrink" :class="[windowMode == 'mini' ? 'visible' : 'invisible']">
    <div class="button-chat color-theme-default resetcustom">
      <i class="close-widget-icon"></i>
    </div>
  </div>
</template>

<script>
export default {
  name: 'close-button',
  computed: {
    windowMode () {
      return this.$store.state.windowMode
    }
  },

  methods: {
    shrink () {
      this.$router.push({ name: 'chat-button' })
    }
  }
}
</script>
